import React, { FunctionComponent } from "react";
import { NumberFormatProps, NumberFormatValues } from "react-number-format";
import { Rubriek } from "components/aangifte/Rubriek";
import { NumberInput } from "components/inputs/NumberInput";

export interface Props extends NumberFormatProps {
  name: string;
}

export const NumberField: FunctionComponent<Props> = ({ name, ...props }) => {
  return (
    <Rubriek code={name}>
      {({ updateValue, rubriek }) => {
        const handleChange = (values: NumberFormatValues) => {
          return updateValue(values.floatValue);
        };

        return (
          <NumberInput
            id={name}
            name={name}
            value={(rubriek.value as number) || ""}
            onValueChange={handleChange}
            {...props}
          />
        );
      }}
    </Rubriek>
  );
};

NumberField.displayName = "NumberField";
